import { useSelector } from "react-redux";
import {
  getClientPortalPayment,
  selectClientPortalPayment,
  selectCreatePaymentResponse,
  selectLoading,
  selectPaymentConfirmationEmail,
} from "../PayNowPageSlice";
import { PaymentConfirmationTable } from "./components/PaymentConfirmationTable";
import { useEffect } from "react";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useParams } from "react-router-dom";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";

export const PaymentConfirmationStep: React.FC = () => {
  const { paymentID } = useParams();
  const thunkDispatch = useThunkDispatch();
  const createPaymentResponse = useSelector(selectCreatePaymentResponse);
  const clientPortalPayment = useSelector(selectClientPortalPayment);
  const isBusy = useSelector(selectLoading);
  const paymentConfirmationEmail = useSelector(selectPaymentConfirmationEmail);
  const clientPortalPaymentID = createPaymentResponse?.clientPortalPaymentID ?? paymentID;

  const isProposedWorkPayment = clientPortalPayment?.proposedWorkID !== null;

  useEffect(() => {
    thunkDispatch(getClientPortalPayment(clientPortalPaymentID));
  }, [clientPortalPaymentID, thunkDispatch]);

  return (
    <ActivityIndicator isBusy={isBusy}>
      <div className="row">
        <p>
          {isProposedWorkPayment
            ? "Thank you for confirming your payment towards the major work. Your payment is processing and you will receive an email confirmation shortly. The work details will be updated accordingly once the funds have been processed. For a detailed breakdown, refer below"
            : "Thank you for confirming your payment. Your payment is processing and you will receive an email confirmation shortly. Your account balance will be updated accordingly once the funds have been processed. For a detailed breakdown, refer below"}
        </p>
      </div>
      <PaymentConfirmationTable />
      {clientPortalPayment?.reference !== null && (
        <div className="row">
          <p>
            <strong>Your payment reference is {clientPortalPayment?.reference}</strong>
          </p>
        </div>
      )}
      {paymentConfirmationEmail !== null && (
        <div className="row">
          <p>A confirmation email has been sent to {paymentConfirmationEmail}</p>
        </div>
      )}
    </ActivityIndicator>
  );
};
